import React from "react";
import "react-dropdown/style.css";
import "../App.css";
import EditableTable, {
  InputCheckbox,
  InputTextbox,
  NumberFormatInputbox,
} from "../gui_components/UIComponents";
import { ColmDef } from "../ds/client_ds";
import { useState } from "react";

const Test = () => {
  const data = [
    { id: 1, isActive: false, name: "Alice", age: 25 },
    { id: 2, isActive: false, name: "Bob", age: 30 },
    { id: 3, isActive: false, name: "Charlie", age: 35 },
  ];

  const colmDef = new ColmDef();
  const columns = [
    {
      Header: "",
      accessor: "isActive",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Age",
      accessor: "age",
    },
  ];
  const [editedData, setEditedData] = useState(data);

  const handleDataChange = (e, rowIndex) => {
    const value = e.target.value;
    const name = e.target.name;
    setEditedData((prevData) => {
      return prevData.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...row,
            [name]: value,
          };
        }
        return row;
      });
    });
  };

  // return <EditableTable data={data} columns={columns} />;
  return (
    <table id="fabrics_tables">
      <thead>
        <tr>
          <th></th>
          <th>Name</th>
          <th>Age</th>
          {/* {columns.map((col) => {
            {
              // !isEmptyString(col.header) ? <th>{col.header}</th> : null;
              // col.Header != null && col.Header != undefined && (
              <th>{col.Header}</th>;
              // );
            }
          })} */}
        </tr>
      </thead>
      <tbody>
        {editedData.map((item, rowIndex) => (
          <tr key={item.id}>
            <td>
              {/* <input
                type="checkbox"
                name={"id"}
                checked={checkedItems}
                onChange={handleCheckboxChange}
              /> */}
              <InputCheckbox
                type="checkbox"
                name="isActive"
                onChange={(event) => handleDataChange(event, rowIndex)}
                checked={item.isActive}
              ></InputCheckbox>
            </td>
            <td>
              {/* <input
                type="text"
                name={"name"}
                value={item.name}
                onChange={(event) => handleDataChange(event, rowIndex)}
              /> */}
              <InputTextbox
                name="name"
                type="text"
                onChange={(event) => handleDataChange(event, rowIndex)}
                value={item.name}
              ></InputTextbox>
            </td>
            <td>
              {/* <input
                type="number"
                name={"age"}
                value={item.age}
                onChange={(event) => handleDataChange(event, rowIndex)}
              /> */}
              <NumberFormatInputbox
                onChange={(event) => handleDataChange(event, rowIndex)}
                disabled={false}
                name="age"
                // decimalScale={2}
                value={item.age}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

function TestInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <Test {...props} name="" /> <br />
    </div>
  );
}

export default TestInquiry;
